
      <app-kontable
              title="{{ 'customerShoppingHabits.details' | translate }}"
              [columns]="[
        'message_id',
        {
            field: 'start_date',
            title: 'customerInfoSheet.startDate',
            bodyTemplate: dateStart
        },
        {
            field: 'end_date',
            title: 'customerInfoSheet.endDate',
            bodyTemplate: dateEnd
        }
        ]"
              [titles]="['promotion.message']"
              [source]="details"
              [showInfoButton]="true"
              [showRecoverButton]="false"
              [showDetailsButton]="false"
              [showAddButton]="true"
              [showGlobalFilter]="false"
              [showEditButton]="true"
              (onRemove)="deleteDetail($event['id'])"
              (onAdd)="showDetailAdd()"
              (onEdit)="showDetailEdit($event)"
              *ngIf="showKontable"
              [name]="'promotion.messageTable'">
          <ng-template #dateStart let-row>
              {{ row['start_date'] | date: 'yyyy-MM-dd' }}
          </ng-template>
          <ng-template #dateEnd let-row>
              {{ row['end_date'] | date: 'yyyy-MM-dd' }}
          </ng-template>
      </app-kontable>
      <kv-promo-tab-detail-form
              *ngIf="showForm"
              [titlePage]="titlePage"
              [addEditDetail]="addEditDetail"
              (backToKontable)="toggleForm(); toggleKontable()"
              [addEditCampaign]="addEditCampaign"
              [configs]="configs"
              [divisionSaleNetworkItems]="divisionSaleNetworkItems"
              [messages]="messages"
              (saveDetail)="saveThisDetail($event)"
              (showNewMessage)="createNewMessage($event)">
      </kv-promo-tab-detail-form>
      <kv-promo-message-detail
              *ngIf="showNewMessage"
              (shortInsertCompleted)=" shortInsertCompleted($event)"
              [shortInsert]="shortInsert"
              [wizards]="wizards"
              [editMessage]="editMessage"
              [discountTypes]="discountTypes"
              [messagesTypes]="messagesTypes"
              [barCodes]="barCodes"
              [clusters]="clusters"
              [templates]="templates"
              [touchPoints]="touchPoints"
              [layouts]="layouts">
      </kv-promo-message-detail>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/tabs/detail/tab-detail.component.ts.TabDetailComponent.html